import { useQuery } from '@tanstack/react-query';
import { getWholesaleGenderCategoryReport, type GenderWholesaleCategoryReport } from "../services/wholesaleGenderCategService";

export const useWholesaleGenderCategoryReport = (start_date: string, end_date: string) => {
  return useQuery<GenderWholesaleCategoryReport[], Error>({
    queryKey: ['wholesale-gender-category', start_date, end_date],
    queryFn: () => getWholesaleGenderCategoryReport(start_date, end_date),
    staleTime: 1000 * 60 * 5,
  });
}